module.exports = __webpack_public_path__ + "img/ic_gongshang_logo_normal.0d55020.png";